export const BRAND = {
  name: "The Vault Barber Co.",
  logo: "/logo-112.webp",
  logo2x: "/logo-224.webp",
  logoOg:
    "https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://assets.cdn.filesafe.space/sgQRenTqJRKU6uAQbElY/media/68653d15f30b955e737c950f.png",
  rating: "4.9",
  reviewCount: "403",
  hours: "Every day · 8AM · 7PM",
  email: "Sebastianandbane@icloud.com",
  textLine: "(214) 898-2102",
};

export const SOCIALS = {
  facebook:
    "https://www.facebook.com/people/The-Vault-Barber-Company-Argyle-Texas/61577858846304/",
  instagramArgyle: "https://www.instagram.com/thevaultbarbercoargyletx/",
  instagramLantana: "https://www.instagram.com/thevaultbarbercompanydfw/",
  tiktok: "https://www.tiktok.com/@thevaultbarbercoargyletx",
};

export const LOCATIONS = [
  {
    id: "argyle",
    city: "Argyle",
    label: "Argyle",
    address: "600 US-377, Argyle, TX 76226",
    phone: "(940) 407-2288",
    tel: "+19404072288",
    note: "Heart of Argyle · Hwy 377 · Walk-ins welcome",
    serves: "Argyle · Lantana · Justin · Denton",
    instagram: "https://www.instagram.com/thevaultbarbercoargyletx/",
    instagramHandle: "@thevaultbarbercoargyletx",
    street: "600 US-377",
    locality: "Argyle",
    postalCode: "76226",
    lat: 33.1212,
    lng: -97.1836,
    booking: "https://thevaultbarberco.com/appointmentbooking-5117-8083",
    maps: "https://www.google.com/maps/search/?api=1&query=600+US-377+Argyle+TX+76226",
  },
  {
    id: "lantana",
    city: "Lantana / Bartonville",
    label: "Lantana",
    address: "2648 FM 407, Suite 120, Bartonville, TX 76226",
    phone: "(682) 305-4874",
    tel: "+16823054874",
    note: "Next door to Marty B's · 5 min from Flower Mound",
    serves: "Lantana · Bartonville · Flower Mound · Double Oak",
    instagram: "https://www.instagram.com/thevaultbarbercompanydfw/",
    instagramHandle: "@thevaultbarbercompanydfw",
    street: "2648 FM 407, Suite 120",
    locality: "Bartonville",
    postalCode: "76226",
    lat: 33.0737,
    lng: -97.135,
    booking:
      "https://thevaultbarberco.com/appointmentbooking-5117-8083-757011",
    maps: "https://www.google.com/maps/search/?api=1&query=2648+FM+407+Suite+120+Bartonville+TX",
  },
];

export const BARBERS = [
  {
    id: "joe",
    name: "Joe",
    locations: ["argyle"],
    tagline: "A1 Bald Fade Master · Premium Barber",
    bio: "Fades, scissor cuts and beard shaping honed from small local shops to high-end grooming rooms. Every chair is art, technique and connection. Does all men's cuts.",
  },
  {
    id: "aj",
    name: "AJ",
    locations: ["argyle"],
    tagline: "Premium Barber · Top 5 female barber in the nation",
    bio: "10+ years in the industry. Short hair taper fades, master of any bald fade, excellent with scissors and next level with waxing. Go-to barber for Cody Allen, Kevin Pillar and Brandon Workman.",
  },
  {
    id: "ashley",
    name: "Ashley Parker",
    locations: ["argyle"],
    tagline: "All types of hair",
    bio: "A legend in taper fades, long hair and beards — and amazing to talk to. Haircut quality you come back for.",
  },
  {
    id: "claire",
    name: "Claire Huggins",
    locations: ["argyle"],
    tagline: "Stylist · Scissor cuts & clean fades",
    bio: "Friendly local stylist, previously with The Board Room and Sport Clips. Specializes in scissor cuts and clean fades, great with kids, and offers flexible late appointments.",
  },
  {
    id: "trae",
    name: "Trae",
    locations: ["argyle"],
    tagline: "Taper legend · Elite tapers & shears",
    bio: "Trained in some of the city's most respected shops including PMC and The Board Room. Elite tapers, seamless blends and detailed beard work, with a chair where people feel welcomed and renewed.",
  },
  {
    id: "lee",
    name: 'Lee "The Fade & Taper King"',
    locations: ["argyle", "lantana"],
    tagline: "Smooth low fades · Precision beard work",
    bio: "Known for smooth low fades and precision beard work. A local legend in the chair, in both shops.",
  },
  {
    id: "jason",
    name: "Jason",
    locations: ["argyle", "lantana"],
    tagline: "Master barber · Andis top instructor 20+ years",
    bio: "Worked for Andis and has been a top instructor of hair for over 20 years. Cuts all hair types and beards, and works both the Bartonville and Argyle chairs.",
  },
  {
    id: "joseline",
    name: "Joseline",
    locations: ["lantana"],
    tagline: "Award winning best female barber in the nation",
    bio: "A local barbering legend from Cool Heads. Clean fades, precision scissor cuts, beard work, waxing and shampoos — and especially amazing with kids.",
  },
  {
    id: "lexi",
    name: 'Lexi "Styles"',
    locations: ["lantana"],
    tagline: "Full service VIP · Celebrity barber",
    bio: "Five years of high-quality men's grooming with attention to every detail. Precision fades, beard detailing, scissor cuts, waxing and color services.",
  },
];

export const barbersFor = (locationId) =>
  BARBERS.filter((b) => b.locations.includes(locationId));

export const SERVICES = [  {
    no: "01",
    name: "Men's Cut",
    price: "$45",
    time: "45 min",
    desc: "Full-service haircut for short to medium length, clippers and/or shears, finished with a hot towel and style.",
  },
  {
    no: "02",
    name: "Beard Trim",
    price: "$30",
    addon: "$20 with a haircut",
    time: "20 min",
    desc: "Precise trimming and shaping to sharpen your jawline and keep the growth intentional, never accidental.",
  },
  {
    no: "03",
    name: "Hot Towel Shave",
    price: "Ask",
    time: "30 min",
    desc: "Straight razor, layered hot towels and premium lather for the smoothest finish in Denton County.",
  },
  {
    no: "04",
    name: "Eyebrow Trim",
    price: "$10",
    time: "10 min",
    desc: "The detail nobody talks about and everybody notices. Clean, natural shaping.",
  },
  {
    no: "05",
    name: "Kid's Cut",
    price: "$40",
    time: "30 min",
    desc: "Patient, friendly and fast. Our barbers are known for first haircuts that don't end in tears.",
  },
  {
    no: "06",
    name: "Shampoo & Style",
    price: "$45+",
    time: "30 min",
    desc: "Scalp massage, specialized products and a finish that holds through a North Texas summer.",
  },
  {
    no: "07",
    name: "Women's Cut & Style",
    price: "Case by case",
    time: "60 min",
    desc: "A personalized cut tailored to your hair type, length and lifestyle. Consultation first, always.",
  },
];

export const GALLERY = [
  {
    url: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://storage.googleapis.com/msgsndr/sgQRenTqJRKU6uAQbElY/media/692372142e932be329864b1e.png",
    title: "Marty B",
    tag: "Local legend",
  },
  {
    url: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://assets.cdn.filesafe.space/sgQRenTqJRKU6uAQbElY/media/6a7e3cdac0662ee5c42e4a82.png",
    title: "Josh Jung",
    tag: "Texas Rangers",
  },
  {
    url: "/cody-allen-800.webp",
    title: "Cody Allen",
    tag: "MLB pitcher",
  },
  {
    url: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://storage.googleapis.com/msgsndr/sgQRenTqJRKU6uAQbElY/media/6977053da87bebb3b5f0f2c9.jpg",
    title: "Skin fade, textured top",
    tag: "Precision",
  },
  {
    url: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://assets.cdn.filesafe.space/sgQRenTqJRKU6uAQbElY/media/6a25e6b96a06f03d449c82e0.png",
    title: "Low taper & lineup",
    tag: "Classic",
  },
  {
    url: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://storage.googleapis.com/msgsndr/sgQRenTqJRKU6uAQbElY/media/6923715a2e932b7dd1863300.png",
    title: "Beard sculpt & crop",
    tag: "Full grooming",
  },
  {
    url: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://assets.cdn.filesafe.space/sgQRenTqJRKU6uAQbElY/media/6a25e6a149e55f85199fd8ae.png",
    title: "Executive taper",
    tag: "Men's standard",
  },
  {
    url: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://assets.cdn.filesafe.space/sgQRenTqJRKU6uAQbElY/media/6865308f38934f41ee1bbfd6.jpeg",
    title: "Grey blend & beard shape",
    tag: "In the chair",
  },
  {
    url: "/old-bank-800.webp",
    srcSet: "/old-bank-400.webp 400w, /old-bank-800.webp 800w",
    title: "The old bank on 377",
    tag: "Argyle shop",
    alt: "The historic old bank building on US-377, Argyle TX · home of The Vault Barber Co.",
  },
];

export const SERVICE_OFFERS = SERVICES.map((s) => {
  const priced = /^\$\d+/.test(s.price);
  return {
    "@type": "Offer",
    itemOffered: { "@type": "Service", name: s.name },
    ...(priced
      ? { price: s.price.replace(/[^0-9]/g, ""), priceCurrency: "USD" }
      : {}),
  };
});

export const byTitle = (title) => GALLERY.find((g) => g.title === title) || GALLERY[0];

export const HERO_SRCSET_WEBP =
  "/hero-640.webp 640w, /hero-960.webp 960w, /hero-1280.webp 1280w";
export const HERO_SRCSET_JPG =
  "/hero-640.jpg 640w, /hero-960.jpg 960w, /hero-1280.jpg 1280w";
export const HERO_IMG = "/hero-960.jpg";

// Single source of truth for the public origin. Flip with:
//   node frontend/scripts/set-domain.js https://thevaultbarber.co
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://thevaultbarber.co"
).replace(/\/+$/, "");
export const siteUrl = (path = "/") =>
  `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
export const HERO_OG = `${SITE_URL}/og-share.jpg`;

export const CHAPTERS = [
  {
    no: "01",
    title: "Unmatched barber skills",
    body: "Some of our barbers have earned celebrity-barber status cutting local celebrities, professional athletes and some of the biggest names in North Texas. That standard doesn't change when it's your turn in the chair.",
  },
  {
    no: "02",
    title: "A room you don't rush out of",
    body: "Low light, good conversation, and a complimentary drink on the house. Argyle and Lantana walk in for a haircut and stay for the atmosphere.",
  },
  {
    no: "03",
    title: "Fair price, elite service",
    body: "Elite barbering at a fair price. Full service, no upsell theatre, no surprise charges. If quality matters, this is your shop.",
  },
];

export const REVIEWS = [
  {
    quote:
      "My beard has never looked this good. The barber took time to shape it perfectly and gave great tips for maintaining it. Highly recommend for anyone serious about their grooming.",
    name: "Michael Smith",
    src: "Google Review",
  },
  {
    quote:
      "Best cut I've had in years. The barbers here truly know their craft. The attention to detail, great conversation, and relaxing atmosphere made it a 10/10 experience.",
    name: "Sarah Williams",
    src: "Google Review",
  },
  {
    quote: "Best bald fade I have ever gotten.",
    name: "Al Berry",
    src: "Google Review",
  },
  {
    quote:
      "Accepts walk-ins, great with kids, and they'll hand you a drink while you wait. This is how a neighborhood barber shop should run.",
    name: "Verified Guest",
    src: "Google Review",
  },
];

export const CELEBS = [
  {
    name: "Josh Jung",
    credit: "Texas Rangers",
    role: "Third baseman",
  },
  {
    name: "Kevin Pillar",
    credit: "Texas Rangers",
    role: "Outfielder",
  },
  {
    name: "Cody Allen",
    credit: "Former Cleveland Indians",
    role: "Closing pitcher",
  },
  {
    name: "Brandon Workman",
    credit: "Former Boston Red Sox",
    role: "Pitcher",
  },
  {
    name: "Marty B",
    credit: "Marty B's, Bartonville",
    role: "North Texas legend",
  },
];

export const MARQUEE_WORDS = [
  "Precision Fades",
  "Beard Sculpting",
  "Hot Towel Shaves",
  "Kids Cuts",
  "Walk-Ins Welcome",
  "Argyle, TX",
  "Lantana, TX",
];

export const LOCATION_PAGES = {
  argyle: {
    slug: "argyle",
    locationId: "argyle",
    h1: ["Barber shop in", "Argyle, Texas"],
    seoTitle:
      "Barber Shop in Argyle, TX | The Vault Barber Co. · 4.9★ Fades & Beard Trims",
    seoDescription:
      "Argyle's highest-rated barber shop at 600 US-377 · 4.9★ from 403+ reviews. Fades, beards, hot towel shaves. Open daily 8AM-7PM — walk in today.",
    intro:
      "We cut hair out of the old bank building on Highway 377 · the one everybody in Argyle knows. Inside it's dark wood, leather chairs and barbers who have been fading heads in Denton County for years. Ten minutes from Lantana, Justin and north Flower Mound, with a complimentary drink waiting on you.",
    landmarks: [
      "In the historic old bank building on US-377",
      "Minutes from Argyle High School and Liberty Christian",
      "Straight up 377 from Lantana and Bartonville",
      "Free parking right out front",
    ],
    neighborhoods: [
      "Argyle",
      "Lantana",
      "Bartonville",
      "Justin",
      "Northlake",
      "Denton",
      "Corinth",
      "Copper Canyon",
    ],
    faqs: [
      {
        q: "Where exactly is your Argyle barber shop?",
        a: "600 US-377, Argyle, TX 76226 · the old bank building on the corner. Free parking out front and walk-ins are welcome all day.",
      },
      {
        q: "Do I need an appointment in Argyle?",
        a: "No, we take walk-ins every day. But Saturday mornings and weekday evenings fill up fast, so booking online gets you the barber and time you actually want.",
      },
      {
        q: "How much is a men's haircut in Argyle?",
        a: "A full-service men's cut is $45, a beard trim is $30 on its own or just $20 added to a haircut, and kids cuts are $40.",
      },
      {
        q: "Are you good with kids?",
        a: "Yes, it's one of the things Argyle families mention most in our reviews. Kids cuts are $40 and our barbers are patient, fast and friendly.",
      },
    ],
  },
  lantana: {
    slug: "lantana",
    locationId: "lantana",
    h1: ["Barber shop for", "Lantana, Texas"],
    seoTitle:
      "Barber Shop near Lantana, TX | The Vault Barber Co. · Fades, Beards & Shaves",
    seoDescription:
      "Lantana's go-to barber shop, next door to Marty B's on FM 407. Fades, beards, hot towel shaves · 4.9★. Open daily 8AM-7PM — walk in today.",
    intro:
      "Our FM 407 shop sits right next door to Marty B's, which makes it the closest chair to Lantana, Bartonville and Double Oak, about five minutes from Flower Mound. Same barbers, same standard, same complimentary drink. Grab a fade, then grab dinner next door.",
    landmarks: [
      "Next door to Marty B's on FM 407",
      "5 minutes from Flower Mound and Double Oak",
      "The closest shop to the Lantana neighborhoods",
      "Suite 120 · easy in, easy out parking",
    ],
    neighborhoods: [
      "Lantana",
      "Bartonville",
      "Double Oak",
      "Flower Mound",
      "Argyle",
      "Highland Village",
      "Copper Canyon",
      "Shady Shores",
    ],
    faqs: [
      {
        q: "Is your shop actually in Lantana?",
        a: "We're at 2648 FM 407, Suite 120 in Bartonville, right on Lantana's doorstep, next door to Marty B's. For most Lantana addresses it's a five minute drive.",
      },
      {
        q: "Can I walk in near Lantana?",
        a: "Yes, walk-ins are welcome every day from 8AM to 7PM. Booking online is still the safest way to lock in a specific barber.",
      },
      {
        q: "What does a cut and beard cost?",
        a: "Men's cut is $45 and adding a beard trim is only $20 more · $65 for the full reset, finished with a hot towel.",
      },
      {
        q: "Who cuts here?",
        a: "The same crew that earned our 4.9★ rating, including barbers who cut Texas Rangers Josh Jung and Kevin Pillar, and Marty B himself from next door.",
      },
    ],
  },
};
